if (!customElements.get('nutrition-facts-slider')) {
  class NutritionFactsSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-nutrition-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-nutrition-thumb]'));
      this.dots = Array.from(this.querySelectorAll('[data-nutrition-dot]'));
      this.titleEl = this.querySelector('[data-nutrition-title]');
      this.prevBtn = this.querySelector('[data-nutrition-prev]');
      this.nextBtn = this.querySelector('[data-nutrition-next]');
      this.viewport = this.querySelector('.nutrition-facts-slider__viewport') || this;
      this.modalContent =
        this.closest('[data-nutrition-modal-content]') ||
        this.closest('.nutrition-facts-modal__content');
      this.index = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains('is-active'))
      );
      this.swipeStartX = 0;
      this.swipeStartY = 0;
      this.swipeActive = false;
      this.swipeDragging = false;
      this.swipeThreshold = 40;

      this.prevBtn?.addEventListener('click', () => this.goTo(this.index - 1));
      this.nextBtn?.addEventListener('click', () => this.goTo(this.index + 1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const target = Number(dot.dataset.nutritionDot);
          if (!Number.isNaN(target)) this.goTo(target);
        });
      });

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const target = Number(thumb.dataset.nutritionThumb);
          if (!Number.isNaN(target)) this.goTo(target);
        });
      });

      this.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
          if (event.key === 'ArrowRight') this.goTo(this.index + 1);
        },
        true
      );

      this.bindSwipe();
      this.goTo(this.index, false);
    }

    bindSwipe() {
      if (this.slides.length <= 1) return;

      const onPointerDown = (event) => {
        if (event.target.closest('[data-nutrition-prev], [data-nutrition-next], [data-nutrition-dot]')) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.swipeActive = true;
        this.swipeDragging = false;
        this.swipeStartX = event.clientX;
        this.swipeStartY = event.clientY;
        this.viewport.setPointerCapture?.(event.pointerId);
      };

      const onPointerMove = (event) => {
        if (!this.swipeActive) return;

        const deltaX = event.clientX - this.swipeStartX;
        const deltaY = event.clientY - this.swipeStartY;

        if (Math.abs(deltaX) > 12 && Math.abs(deltaX) > Math.abs(deltaY)) {
          this.swipeDragging = true;
          event.preventDefault();
        }
      };

      const onPointerUp = (event) => {
        if (!this.swipeActive) return;
        this.swipeActive = false;

        const deltaX = event.clientX - this.swipeStartX;
        const deltaY = event.clientY - this.swipeStartY;
        const wasDragging = this.swipeDragging;
        this.swipeDragging = false;

        if (!wasDragging) return;
        if (Math.abs(deltaX) < this.swipeThreshold) return;
        if (Math.abs(deltaX) < Math.abs(deltaY)) return;

        if (deltaX < 0) {
          this.goTo(this.index + 1);
        } else {
          this.goTo(this.index - 1);
        }
      };

      this.viewport.addEventListener('pointerdown', onPointerDown);
      this.viewport.addEventListener('pointermove', onPointerMove, { passive: false });
      this.viewport.addEventListener('pointerup', onPointerUp);
      this.viewport.addEventListener('pointercancel', () => {
        this.swipeActive = false;
        this.swipeDragging = false;
      });

      // Prevent native image drag interfering with swipe on desktop Safari
      this.viewport.querySelectorAll('img').forEach((img) => {
        img.setAttribute('draggable', 'false');
        img.addEventListener('dragstart', (event) => event.preventDefault());
      });
    }

    goTo(nextIndex, focus = true) {
      if (!this.slides.length) return;

      const total = this.slides.length;
      this.index = ((nextIndex % total) + total) % total;

      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
      });

      this.thumbs.forEach((thumb) => {
        const thumbIndex = Number(thumb.dataset.nutritionThumb);
        const active = thumbIndex === this.index;
        thumb.classList.toggle('is-active', active);
        thumb.style.zIndex = active ? String(this.thumbs.length + 1) : String(this.thumbs.length - thumbIndex);
      });

      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      const title = this.slides[this.index]?.dataset.nutritionSlideTitle;
      if (this.titleEl && title) {
        this.titleEl.textContent = title;
      }

      const color = this.slides[this.index]?.dataset.nutritionSlideColor;
      if (this.modalContent && color) {
        this.modalContent.style.setProperty('--nutrition-modal-bg', color);
        this.modalContent.style.backgroundColor = color;
      }

      if (focus) {
        this.slides[this.index]?.querySelector('img')?.focus?.();
      }
    }
  }

  customElements.define('nutrition-facts-slider', NutritionFactsSlider);
}

if (!window.__nutritionFactsInlineBound) {
  window.__nutritionFactsInlineBound = true;

  const openNutritionFactsModal = (trigger) => {
    const modal = document.querySelector('modal-dialog.nutrition-facts-modal');
    if (modal && typeof modal.show === 'function') {
      modal.show(trigger);
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-nutrition-facts-open]');
    if (trigger) {
      event.preventDefault();
      openNutritionFactsModal(trigger);
      return;
    }

    const fallback = event.target.closest('.accordion__content span, .accordion__content a, .accordion__content u');
    if (!fallback) return;
    if (!/view\s+supplement\s+facts/i.test((fallback.textContent || '').trim())) return;

    event.preventDefault();
    openNutritionFactsModal(fallback);
  });
}

